export default (dis, store, client) => {
    function markComplete(id) {
      return client.post(`/api/user_tutorials/${id}/mark_complete`)
    }
  
    return { markComplete }
}